<template>
  <div v-if="access !== null">
    <lembaga-popup
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
      :userList="userList"
    />
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <header class="w-full">
        <div class="mb-base mt-4 vx-row justify-between items-top">
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
            <span class="text-black text-2xl">Tabel Sahabat ZX</span>
          </section>
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
            <vs-button @click="openPopUp(null)" v-if="access.create === 1"
              >Tambah Sahabat ZX</vs-button
            >
          </section>
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="dialogDelete" v-if="access.delete === 1">
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="vx-row justify-end items-center">
              <v-select
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full lg:mr-0"
                v-model="lembaga"
                :reduce="(v) => v.id"
                :options="[
                  {
                    id: 1,
                    text: 'Organisasi Pengelola Zakat',
                  },
                  {
                    id: 2,
                    text: 'Organisasi Non Pengelola Zakat',
                  },
                ]"
                label="text"
                placeholder="Pilih Status Lembaga"
              />
              <vs-input
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full"
                v-model="search"
                placeholder="Cari..."
              />
            </div>
          </section>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </header>

      <main ref="loadLembaga">
        <vs-table stripe :data="lembagas" v-model="selected" :max-items="limit" multiple>
          <template slot="thead">
            <vs-th>Nama</vs-th>
            <vs-th>User</vs-th>
            <vs-th>Status Lembaga</vs-th>
            <vs-th>Verifikasi</vs-th>
            <vs-th>Aksi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>
              <vs-td
                :data="data[indextr].user"
                :style="data[indextr].user ? 'color: black;' : 'color: red;'"
              >
                {{ data[indextr].user ? data[indextr].user.name : "(User Kosong)" }}
              </vs-td>
              <vs-td :data="data[indextr].status_lembaga">
                {{
                  data[indextr].status_lembaga
                    ? data[indextr].status_lembaga.name
                    : "Null"
                }}
              </vs-td>
              <vs-td
                :data="data[indextr].user"
                :style="
                  data[indextr].user
                    ? data[indextr].user.status === 1
                      ? 'color: green;'
                      : 'color: red;'
                    : 'color: red;'
                "
              >
                {{
                  data[indextr].user
                    ? data[indextr].user.status === 1
                      ? "Verify"
                      : "Un-Verify"
                    : "(User Kosong)"
                }}
              </vs-td>
              <vs-td>
                <div class="flex justify-start gap-2">
                  <vs-button
                    v-if="access.update === 1"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="openPopUp(data[indextr])"
                  >
                  </vs-button>
                  <vs-button
                    v-if="access.delete === 1"
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="dialogDelete(data[indextr].id, data[indextr].name)"
                  >
                  </vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </main>
      <footer>
        <div class="justify-end mt-2">
          <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
        </div>
      </footer>
    </vx-card>
  </div>
</template>

<script>
import LembagaPopup from "@/views/lembaga/component/LembagaPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";

export default {
  components: {
    LembagaPopup,
  },
  data() {
    return {
      emptyImage,
      params: {},
      kategoriList: [],
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      passData: null,
      userList: [],
      filterType: "",
      lembaga: null,
      metodePembayaran: [],
      jenisPembayaran: [],
      selected: [],
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      currentPg: 1,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      lembagas: [],
      access: null,
      search: "",
    };
  },
  computed: {
    totalPage() {
      let pages = this.$store.state.lembaga.totalRecords / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
    filter() {
      return {
        search: this.search,
        lembaga: this.lembaga,
      };
    },
  },
  watch: {
    filter: {
      handler(v) {
        let searchObj = {};
        let lembagaObj = {};

        if (v.search !== "") {
          searchObj = {
            search: this.search,
            filter: "name",
          };
        } else {
          searchObj = {};
        }

        if (v.lembaga !== null) {
          lembagaObj = {
            status_lembaga: this.lembaga,
          };
        } else {
          lembagaObj = {};
        }

        this.params = { ...searchObj, ...lembagaObj };
        this.getData();
      },
      deep: true,
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  methods: {
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    openPopUp(item) {
      if (item.user === null) {
        this.$vs.notify({
          position: "top-right",
          title: "Tidak Dapat Melakukan Aproval!",
          text: `Karena user dari lembaga ${item.name} tidak diketahui`,
          iconPack: "feather",
          icon: "icon-smile",
          color: "danger",
        });
      } else {
        this.active = true;
        this.passData = item;
      }
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadLembaga,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("lembaga/cudLembaga", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Lembaga ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadLembaga);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getUsers() {
      this.$store
        .dispatch("users/getUsers", {})
        .then((v) => {
          this.userList = v.data;
        })
        .catch((e) => {
          if (e.response) {
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadLembaga,
        color: "primary",
      });
      this.$store
        .dispatch("lembaga/getLembaga", { ...this.params, ...this.pagination })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadLembaga);
          this.lembagas = v.data;
          // console.log(this.lembagas.length)
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadLembaga);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    if (this.$store.state.users.userList.length === 0) {
      this.getUsers();
    } else {
      this.userList = this.$store.state.users.userList;
    }

    // if(this.$store.state.transaksi.metodeList.length !== 0){
    //   this.metodePembayaran = this.$store.state.transaksi.metodeList
    // }else{
    //   this.getMetodePembayaran();
    // }

    // if(this.$store.state.transaksi.jenisList.length !== 0){
    //   this.jenisPembayaran = this.$store.state.transaksi.jenisList
    // }else{
    //   this.getJenisPembayaran();
    // }

    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/sahabat-zx"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/sahabat-zx"
        );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
